import { render } from "./TrendingAuthorsList.vue?vue&type=template&id=3e7316fa"
import script from "./TrendingAuthorsList.vue?vue&type=script&lang=js"
export * from "./TrendingAuthorsList.vue?vue&type=script&lang=js"

import "./TrendingAuthorsList.vue?vue&type=style&index=0&id=3e7316fa&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__